import BlogTable from "components/Cards/BlogTable";
import React from "react";


export default function Blog() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <BlogTable />
        </div>
      </div>
    </>
  );
}
